module.exports = __webpack_public_path__ + "assets-cabinet/img/checked.24fadece.svg";